<template>
  <div
    :class="`bg-${tagColor}-100 text-${tagColor}-700 relative inline-flex items-center text-sm rounded overflow-hidden`"
  >
    <span
      class="max-w-xs truncate px-2 py-1 text-xs font-semibold leading-relaxed"
      x-text="tag"
    >
      {{ label }}
    </span>
    <button
      v-if="!readOnly"
      :class="`w-7 h-7 inline-block align-middle text-${tagColor}-500 bg-${tagColor}-200 focus:outline-none`"
      @click="emit('removeOption')"
    >
      <span class="sr-only">Remove option</span>
      <svg
        class="mx-auto size-6 fill-current"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fill-rule="evenodd"
          d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
        />
      </svg>
    </button>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  label: {
    type: String,
    default: undefined,
  },
  tagColor: {
    type: String,
    default: 'indigo',
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['removeOption']);
</script>
